import { Trans } from "@lingui/react/macro";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import styles from "./NotUsingAppChip.module.scss";

const NotUsingAppChip = () => {
  return (
    <CustomProperties className={styles["not-using-app"]}>
      <Chip border="solid" background="solid" shape="sharp" size="small">
        <Trans>Använder inte Medomas patientapp</Trans>
      </Chip>
    </CustomProperties>
  );
};

export default NotUsingAppChip;
